import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };
  success: any;
  apiUrl: string = environment.apiUrl;
  apiUrlV4: string = environment.apiUrlV4;

  constructor(public http: HttpClient) {}

  async getAllSites() {
    return await this.http
      .get(environment.apiUrl + 'GetAllsites', this.httpOptions)
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }

  async postData(model: any) {
    let accessToken = localStorage.getItem('accessToken');
    const token = accessToken == null ? '' : 'Bearer ' + accessToken;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return await this.http
      .post(
        environment.apiUrl + 'InsertUpdateTransactionDetails',
        model,
        this.httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
  async postRazorPaymentDetails(data: any) {
    let accessToken = localStorage.getItem('accessToken');
    const token = accessToken == null ? '' : 'Bearer ' + accessToken;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return await this.http
      .post(environment.apiUrl + 'GetPaymentStatus', data, this.httpOptions)
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
  setLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
  }
  removeLocalStorage(key: string) {
    localStorage.removeItem(key);
  }
  getLocalStorage(key: string) {
    let value: any;
    value = '';
    if (
      localStorage.getItem(key) != '' &&
      localStorage.getItem(key) != null &&
      localStorage.getItem(key) != undefined
    ) {
      value =
        localStorage.getItem(key) == null ? '' : localStorage.getItem(key);
    }
    console.log('value', value);
    return value;
  }
  async insertLogs(data: any) {
    let accessToken = localStorage.getItem('accessToken');
    const token = accessToken == null ? '' : 'Bearer ' + accessToken;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return await this.http
      .post(environment.apiUrl + 'InsertLogs ', data, this.httpOptions)
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }

  //   async sendOTP(orderId:any,mobile:any) {
  //     let accessToken = localStorage.getItem('accessToken');
  //    const token = accessToken ==null?'':'Bearer ' +accessToken;
  //    this.httpOptions = {
  //      headers: new HttpHeaders({
  //        'Content-Type': 'application/json',
  //        'Authorization': token
  //      })
  //    }
  //    return await this.http.get(environment.apiUrl+'SendOTPforPayment?orderId='+orderId+'&pNum='+mobile, this.httpOptions)
  //    .toPromise().then(result => {
  //      this.success = true;
  //      return result;
  //    },
  //      error => {
  //        this.success = false;
  //        console.log('oops', error);
  //        return (error);
  //      });
  //  }

  async sendOTP(orderId: any, mobile: any) {
    return await this.http
      .get(
        environment.apiUrl +
          'SendOTPforPayment?orderId=' +
          orderId +
          '&pNum=' +
          mobile,
        this.httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }

  async getRedeemRedirectUrl(storeId: any, bName: any, sName?: any) {
    return await this.http
      .get(
        environment.apiUrl +
          'GetRedeemRedirectUrl?storeId=' +
          storeId +
          '&bName=' +
          bName +
          '&sName=' +
          sName,
        this.httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
  ///InsertProductInfo`
  async postProductInfo(data: any) {
    let accessToken = null;
    const token = accessToken == null ? '' : 'Bearer ' + accessToken;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return await this.http
      .post(
        environment.apiUrl + 'InsertProductInfoFromRedeem ',
        data,
        this.httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }

  async insertQSInfo(data: any) {
    let accessToken = localStorage.getItem('accessToken');
    const token = accessToken == null ? '' : 'Bearer ' + accessToken;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: token,
      }),
    };
    return await this.http
      .post(
        environment.apiUrl + 'CheckQSValidateStatus',
        data,
        this.httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
  async GetBinSeries(bankName: any) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        applicationId: 'Hw0w2M731K5cIlh',
      }),
    };

    return await this.http
      .get(
        environment.apiUrl + 'GetBinSeries?bankName=' + bankName,
        httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
  async GetRazorPayKey() {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        applicationId: 'Hw0w2M731K5cIlh',
      }),
    };
    return await this.http
      .get(environment.apiUrl + 'GetRazorPayKey', httpOptions)
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
  async UpdateTransactionFailurinInput(orderId: any, status: any) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        applicationId: 'Hw0w2M731K5cIlh',
      }),
    };
    return await this.http
      .get(
        environment.apiUrl +
          'UpdateTransactionFailurinInput?orderId=' +
          orderId +
          '&status=' +
          status,
        httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
  getTermsAndConditions(data: any) {
    return this.http.post(`${environment.apiUrl}/GetTermDetailByStoreId`, data);
  }

  async getCampaignDetailsByCampaignId(id:any) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        applicationId: 'Hw0w2M731K5cIlh',
      }),
    };

    return await this.http
      .get(
        environment.apiUrlV4 +
          `GetCampaignDetailsById?id=${encodeURIComponent(
            id
          )}`,
        httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }

  async insertUpdateCampaignSubmission(data: any) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        applicationId: 'Hw0w2M731K5cIlh',
        'api-key': 'yFlMjSup.IbHOCjyRiTb8QOO9Ltsbr',
      }),
    };

    return await this.http
      .post(
        environment.apiUrlV4 + 'InsertUpdateCampaignSubmission',
        data,
        httpOptions
      )
      .toPromise()
      .then(
        (result) => {
          this.success = true;
          return result;
        },
        (error) => {
          this.success = false;
          console.log('oops', error);
          return error;
        }
      );
  }
}
